module.exports = "/_next/static/images/96fd2544f8c2ad73efb45aaa156f3a9e-iPhone12pro_2.png.webp";